<template>
  <SubNavCardVue :buttons="buttons" />
</template>

<script>
import SubNavCardVue from "../../components/cards/SubNavCard.vue";

export default {
  components: { SubNavCardVue },
  data() {
    return {
      buttons: [
        {
          label: "Fournisseurs",
          icon: "bi bi-person-lines-fill",
          route: "suppliers-index",
        },
        {
          label: "Nouveau fournisseur",
          icon: "bi bi-person-plus-fill",
          route: "suppliers-create",
        },
      ],
    };
  },
};
</script>
